// src/components/LoadingGallery.js
export default function LoadingGallery() {
    return (
      <div className="max-w-4xl mx-auto px-4 py-6 space-y-4">
        {/* title skeleton */}
        <div className="h-6 w-1/3 bg-gray-300 rounded animate-pulse" />
  
        {/* card skeletons */}
        <div className="flex space-x-4 overflow-x-auto pb-2">
          {[1,2,3].map((n) => (
            <div
              key={n}
              className="shrink-0 w-5/6 md:w-3/5 h-48 bg-gray-300 rounded-lg animate-pulse"
            />
          ))}
        </div>
      </div>
    );
  }
  